import { useToast } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CompareToastContent } from '../../components/CompareToastContent';
import { clearComparisonToast } from '../../reducers/comparisonToast';
import { selectComparisonToast } from '../../selectors/comparisonToast';
import { trackClickComparisonPopup } from '../../utils/tracking';

const COMPARISON_TOAST_HIDE_DELAY = 5000;

export const CompareToastContainer: React.FC = () => {
  const dispatch = useDispatch();
  const toastData = useSelector(selectComparisonToast);
  const toast = useToast({ placement: 'bottom-right', hideDelay: COMPARISON_TOAST_HIDE_DELAY, size: 'L' });

  React.useEffect(() => {
    if (!toastData) {
      return;
    }

    toast.open({
      type: toastData.isError ? 'error' : 'success',
      hasCloseIcon: false,
      content: (
        <CompareToastContent
          text={toastData.text}
          comparisonUrl={toastData.comparisonUrl}
          onClick={() =>
            trackClickComparisonPopup({
              newbuildingId: toastData.newbuildingId,
              category: toastData.category,
            })
          }
        />
      ),
    });

    dispatch(clearComparisonToast());
  }, [toastData, toast, dispatch]);

  return null;
};

CompareToastContainer.displayName = 'CompareToastContainer';
